
import LensunHeader from "../header/lensun/headerlensun"
import "./back.css"

function BackDiseño(){ 
   return(
    <>
       
      
    <body>
    <LensunHeader />
    <section className="fotos">
    <div class="container px-4 px-lg-5 mt-5">
            <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                <div class="col mb-5 row-25">
                  <div className="principal"> 
                    <div class="card h-100">
                        <img  src= "https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FWCU-KJ021.jpg?alt=media&token=03a95bc4-ddcb-40c6-9463-93ad35428da0" alt="..."/> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">KJ021</h5>
                            </div>
                           </div>
                         
                    </div>
                </div>
              </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-041.jpg?alt=media&token=bb752324-5009-4103-8c9b-555091866d33" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">MR027</h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                
                <div class="col mb-5">
                  <div className="principal"> 
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-DW041.jpg?alt=media&token=23719f21-2fc4-4c68-b10a-39d5a6c36270" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">DW041 </h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-DY036.jpg?alt=media&token=3d67a1c0-bbd0-46b7-8526-614a921cdd67" alt="imagen de back" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">DY036 </h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-KJ001.jpg?alt=media&token=c8917791-3b65-47e7-a953-c7207ac3b691" alt="..."/>
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">KJ001 </h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-KT085.jpg?alt=media&token=beec50df-07a8-4811-9844-c391290e20eb" alt="..."  />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">KT085 </h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK%20WCU-KT053.jpg?alt=media&token=3abb4af7-5f8d-43de-9ed2-541f02577892" alt="..."  />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">KT053 </h5>
                               </div>
                             </div>
                        </div> 
                     </div>
                   </div>
                   <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fdise%C3%B1o%2FBACK-ZR037.jpg?alt=media&token=af42515f-8506-4a25-8b36-1e8bb61093db" alt="..."  />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">ZR037 </h5>
                               </div>
                             </div>
                        </div> 
                     </div>
                   </div>
          
          </div>
        </div>
        
    </section>
 </body>   

 </>
   )
}
 
export default BackDiseño